import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp, fadeLeft, fadeRight, scaleIn } from './variants';

const VARIANTS = {
  up: fadeUp,
  left: fadeLeft,
  right: fadeRight,
  scale: scaleIn,
};

export default function MotionReveal({
  as = 'div',
  children,
  className,
  direction = 'up',
  delay = 0,
  viewport = { once: true, amount: 0.12, margin: '-48px 0px' },
  ...rest
}) {
  const Comp = motion[as] || motion.div;

  return (
    <Comp
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={viewport}
      variants={VARIANTS[direction] || fadeUp}
      transition={{ delay }}
      {...rest}
    >
      {children}
    </Comp>
  );
}
